<template>
    <div v-if="getAvailableOneClickPaymentMethods.length > 0">
        <template v-for="paymentMethod in getAvailableOneClickPaymentMethods">
            <component :is="paymentMethod.component"
                       :product-data="product"
                       :variant-data="variant"
                       :disabled="disabled"
                       :payment-method="paymentMethod"></component>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'oneClickCheckout',
        props: {
            product: {
                type: Object,
                required: true,
            },
            variant: Object,
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            ...mapGetters('checkout', [
                'getAvailableOneClickPaymentMethods'
            ]),
        }
    }
</script>
